module.exports = __webpack_public_path__ + "static/media/christmas hat.b89f363c.gif";